import React from "react";
import { PieChart, Pie, Cell, Legend, Tooltip, ResponsiveContainer } from "recharts";

const COLORS = ["#ea580c", "#94a3b8"]; // orange for subscribed, gray for not subscribed

export default function UserSubscriptionPie({ totalUsers, totalSubscribers }) {
  const notSubscribed = totalUsers - totalSubscribers;
  const data = [
    { name: "Subscribed", value: totalSubscribers },
    { name: "Not Subscribed", value: notSubscribed < 0 ? 0 : notSubscribed },
  ].filter(item => item.value > 0);

  // Handle edge cases
  const hasNoData = totalUsers === 0 || data.length === 0;
  const hasSingleCategory = data.length === 1;
  const subscribedPercent = totalUsers > 0 ? ((totalSubscribers / totalUsers) * 100).toFixed(0) : 0;

  if (hasNoData) {
    return (
      <div className="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-800 rounded-xl p-5">
        <h4 className="text-sm font-semibold mb-4 text-gray-900 dark:text-white">
          Users vs. Subscribers
        </h4>
        <div className="flex items-center justify-center h-[180px]">
          <div className="text-center">
            <p className="text-sm text-gray-500 dark:text-gray-400">No user data yet</p>
            <p className="text-xs text-gray-400 dark:text-gray-500 mt-1">Data will appear as users register</p>
          </div>
        </div>
      </div>
    );
  }

  if (hasSingleCategory) {
    return (
      <div className="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-800 rounded-xl p-5">
        <h4 className="text-sm font-semibold mb-4 text-gray-900 dark:text-white">
          Users vs. Subscribers
        </h4>
        <div className="flex items-center justify-center h-[180px]">
          <div className="text-center">
            <div className="inline-flex items-center justify-center w-24 h-24 rounded-full bg-gradient-to-br from-orange-100 to-orange-50 dark:from-orange-500/20 dark:to-orange-500/10 mb-3">
              <div className="text-center">
                <div className="text-2xl font-bold text-orange-600 dark:text-orange-400">{subscribedPercent}%</div>
                <div className="text-xs text-orange-600/70 dark:text-orange-400/70">{data[0].name}</div>
              </div>
            </div>
            <p className="text-xs text-gray-400 dark:text-gray-500">No comparison data yet</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-800 rounded-xl p-5">
      <h4 className="text-sm font-semibold mb-4 text-gray-900 dark:text-white">
        Users vs. Subscribers
      </h4>
      <ResponsiveContainer width="100%" height={180}>
        <PieChart>
          <Pie
            data={data}
            dataKey="value"
            nameKey="name"
            innerRadius={50}
            outerRadius={70}
            fill="#8884d8"
            label={false}
            strokeWidth={0}
          >
            {data.map((entry, index) => (
              <Cell key={`slice-${index}`} fill={COLORS[index % COLORS.length]} />
            ))}
          </Pie>
          <Tooltip 
            contentStyle={{
              backgroundColor: 'rgba(255, 255, 255, 0.95)',
              border: '1px solid #e5e7eb',
              borderRadius: '8px',
              fontSize: '11px',
              padding: '6px 10px'
            }}
          />
          <Legend 
            verticalAlign="bottom" 
            height={28}
            iconType="circle"
            wrapperStyle={{ fontSize: '11px' }}
          />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
}
